<template>
  <div class="flex items-center justify-between px-5 py-4 bg-gray-100 border-b">
    <div class="flex items-center">
      <AssigneeDropdown
        :assignee="conversation.assignedTo"
        @onItemClicked="updateAssignee"
      />
      <StatusDropdown
        :status="conversation.status"
        @onItemClicked="updateStatus"
      />
    </div>
    <!-- <div class="flex items-center">
      <button>
        <svg
          viewBox="0 0 24 24"
          stroke="currentColor"
          fill="none"
          class="h-6 w-6 text-gray-600"
        >
          <path
            d="M19 9l-7 7-7-7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
      <button class="ml-2">
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          class="h-6 w-6 text-gray-600"
        >
          <path
            d="M5 16l7-7 7 7"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></path>
        </svg>
      </button>
    </div> -->
  </div>
</template>

<script>
import AssigneeDropdown from "./AssigneeDropdown";
import StatusDropdown from "./StatusDropdown";

export default {
  components: {
    AssigneeDropdown,
    StatusDropdown
  },
  props: {
    conversation: {
      type: Object
    }
  },
  methods: {
    updateAssignee(userId) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "replace",
          value: userId,
          type: "owner"
        }
      });
    },
    updateStatus(status) {
      this.$store.dispatch("Inbox/putAction", {
        conversationId: this.conversation.id,
        requestParams: {
          action: "replace",
          value: status,
          type: "status"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
